import { createContext } from 'react';

import { SelectedOwnerContextProps } from './SelectedOwnerContext.types';

export const SelectedOwnerContext = createContext<SelectedOwnerContextProps | undefined>(undefined);
